import { type Common } from './common.js';
import type * as EhrTimeSlot from './models/ehrTimeSlot.js';

export class API {
  common: Common;
  baseEndpoint = '/patient-previsit/ehr-time-slot-bookings';

  constructor(common: Common) {
    this.common = common;
  }

  async cancelBooking(id: string) {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }

  async getBookingInfo(id: string): Promise<EhrTimeSlot.TimeSlotConfirmation> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { confirmationInformation } = await this.common.getJSON(url);
    return confirmationInformation;
  }

  async fetchBySchedulingFormSetId(
    schedulingFormSetId: string
  ): Promise<EhrTimeSlot.SafeEhrTimeSlotBookings> {
    const url = this.common.constructPath(this.baseEndpoint, {
      scheduledFromPrevisitFormSetId: schedulingFormSetId,
    });
    return await this.common.getJSON(url);
  }
}
